import CountdownTimer from './CountdownTimer';
import { weeks, pickerPct, fromWei } from "./constants";

const Current = ( {genesisTimestamp, weekNumber, amount, nbPlayers, symbol,
  amountPerBet, enabled, walletAddress, onBetPressed }) => {

  const endOfLottery = (genesisTimestamp + (weekNumber + 1) * weeks)*1000;
  const betAmountWei = amountPerBet * 1e18;

  return (
    <section className="current">
      <h2>Current Lottery: #{weekNumber}</h2>
      <div className="grid">
        <div>
          <h4>{fromWei(amount)} <span>{symbol}</span></h4>
          <p>Amount to win</p>
        </div>
        <div>
          <h4>{(nbPlayers*amountPerBet*pickerPct)/100} <span>{symbol}</span></h4>
          <p>Picker reward</p>
        </div>
        <div>
          <h4>{nbPlayers}</h4>
          <p>Bets</p>
        </div>
        <div>
          { genesisTimestamp!==0 && weekNumber!==-1
            ? <CountdownTimer 
              targetDate={endOfLottery}
            />
            : <h4 className='time'>&nbsp;</h4>
          }
          <p>Remaining time</p>
        </div>
          {enabled && (walletAddress.length > 0)
            ? <button onClick={() => onBetPressed(betAmountWei)}>Bet {amountPerBet} <span>{symbol}</span></button>
            : <button className="deactivated">Bet {amountPerBet} <span>{symbol}</span></button>
          }
      </div>
    </section>
  )
}

export default Current